/**
 * Tela pra colar credenciais manualmente. Util pra testes e admin
 * standalone. Em integracoes embedded, credenciais chegam via URL params
 * e essa tela e pulada automaticamente.
 */
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Captions, Save } from 'lucide-react';
import { setCredenciais } from '../lib/auth';

export default function Credenciais() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') ? decodeURIComponent(params.get('next')!) : '/';

  const [apiKey, setApiKey] = useState('');
  const [userId, setUserId] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [persistir, setPersistir] = useState(true);

  const valido = apiKey.startsWith('fk_') && userId.trim().length > 0;

  const salvar = (e: React.FormEvent) => {
    e.preventDefault();
    if (!valido) return;
    setCredenciais(
      {
        apiKey: apiKey.trim(),
        userId: userId.trim(),
        userEmail: userEmail.trim() || null,
      },
      persistir,
    );
    nav(next, { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6 max-w-md w-full">
        <div className="flex items-center gap-2 mb-1">
          <Captions className="w-6 h-6 text-purple-600" />
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">FilmakerAI</h1>
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
          Cole as credenciais do sistema host. Você recebe a apiKey quando o admin do
          FilmakerAI cadastra seu host (POST /api/v1/admin/hosts).
        </p>

        <form onSubmit={salvar} className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              API Key (X-Api-Key) <span className="text-red-500">*</span>
            </label>
            <input
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="fk_..."
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm font-mono"
              autoComplete="off"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              User ID (X-User-Id) <span className="text-red-500">*</span>
            </label>
            <input
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="ID do usuário no sistema host"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Email <span className="text-gray-400 dark:text-gray-500">(opcional)</span>
            </label>
            <input
              type="email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              placeholder="seu@email.com"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm"
            />
          </div>

          <label className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mt-2">
            <input
              type="checkbox"
              checked={persistir}
              onChange={(e) => setPersistir(e.target.checked)}
            />
            Lembrar neste dispositivo (localStorage)
          </label>

          <button
            type="submit"
            disabled={!valido}
            className="w-full mt-2 flex items-center justify-center gap-2 px-3 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm rounded disabled:opacity-50"
          >
            <Save className="w-4 h-4" /> Entrar
          </button>
        </form>

        <p className="mt-4 text-xs text-gray-400 dark:text-gray-500">
          As credenciais ficam apenas no seu navegador. O FilmakerAI confia no sistema host
          que autenticou você antes desta chamada.
        </p>
      </div>
    </div>
  );
}
